import { Component } from '@theme/component';

/**
 * A component that removes the section it's positioned in when its button is clicked.
 */
export class RemoveSectionButtonComponent extends Component {
  removeSection() {
    this.closest('.shopify-section')?.remove();
  }
}

if (!customElements.get('remove-section-button-component')) {
  customElements.define('remove-section-button-component', RemoveSectionButtonComponent);
}
